import React from "react";

const TermsAndConditionsPrescriber = ({
  registerForm,
  handleChangeCheckBox,
  getBrochure,
}) => {
  return (
    <React.Fragment>
      <div className="prescriber-confirmation">
        <div className="confirm mb-3">
          When prescribing lenalidomide, I accept responsibility to:
        </div>
        <label htmlFor="confirmation_terms" className="custom-checkbox">
          1. Read and understand the{" "}
          <span
            className="brochure-link"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              getBrochure();
            }}
          >
            Lenalidomide Healthcare Professional Brochure.
          </span>
          <input
            type="checkbox"
            id="confirmation_terms"
            name="confirmation_terms"
            checked={registerForm.confirmation_terms || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label
          htmlFor="confirmation_reqs_compliance"
          className="custom-checkbox"
        >
          2. Comply with all of the Pregnancy Prevention Programme requirements,
          as defined in the Summary of Product Characteristics and the
          Lenalidomide{" "}
          <span
            className="brochure-link"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              getBrochure();
            }}
          >
            Healthcare Professional Brochure.
          </span>
          <input
            type="checkbox"
            id="confirmation_reqs_compliance"
            name="confirmation_reqs_compliance"
            checked={registerForm.confirmation_reqs_compliance || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_auth" className="custom-checkbox">
          3. Complete a ‘Prescription Authorisation Form' with each prescription
          of Lenalidomide.
          <input
            type="checkbox"
            id="confirmation_auth"
            name="confirmation_auth"
            checked={registerForm.confirmation_auth || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_supervised" className="custom-checkbox">
          4. Do a medically supervised pregnancy test within the 3 days before
          the prescription date for women of child bearing potential
          <input
            type="checkbox"
            id="confirmation_supervised"
            name="confirmation_supervised"
            checked={registerForm.confirmation_supervised || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label
          htmlFor="confirmation_aged_verification"
          className="custom-checkbox"
        >
          5. Prescribe no more than a 4 week supply for women of childbearing
          potential, and 12 weeks for males and women of non-childbearing
          potential
          <input
            type="checkbox"
            id="confirmation_aged_verification"
            name="confirmation_aged_verification"
            checked={registerForm.confirmation_aged_verification || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
        <label
          htmlFor="confirmation_risc_of_lenalidomide"
          className="custom-checkbox"
        >
          6. Confirm that women of childbearing potential have been initially
          counselled and reminded about the expected teratogenic risk of
          Lenalidomide and the need to avoid pregnancy
          <input
            type="checkbox"
            id="confirmation_risc_of_lenalidomide"
            name="confirmation_risc_of_lenalidomide"
            checked={registerForm.confirmation_risc_of_lenalidomide || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
        <label htmlFor="confirmation_contraception" className="custom-checkbox">
          7. Confirm that women of childbearing potential have been on at least
          one effective method of contraception for at least 4 weeks
          <input
            type="checkbox"
            id="confirmation_contraception"
            name="confirmation_contraception"
            checked={registerForm.confirmation_contraception || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
        <label
          htmlFor="confirmation_male_risc_of_lenalidomide"
          className="custom-checkbox"
        >
          8. Confirm that male patients have been initially counselled and
          reminded about the expected teratogenic risk of lenalidomide and
          understand the need to use a condom, if involved in sexual activity
          with a pregnant woman or a woman of childbearing potential not using
          effective contraception (even if the male patient has had a vasectomy)
          <input
            type="checkbox"
            id="confirmation_male_risc_of_lenalidomide"
            name="confirmation_male_risc_of_lenalidomide"
            checked={
              registerForm.confirmation_male_risc_of_lenalidomide || false
            }
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
      </div>
      <div className="confirm">
        By clicking ‘Register’, I confirm that I am a prescriber appropriately
        experienced in managing immunomodulatory drugs and that I have read and
        understand the{" "}
        <span
          className="brochure-link"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            getBrochure();
          }}
        >
          Healthcare Professional Brochure
        </span>{" "}
        and agree to comply with all the elements of the Pregnancy Prevention
        Programme described within it.
      </div>
    </React.Fragment>
  );
};
export default TermsAndConditionsPrescriber;
